import { useLazyQuery } from '@apollo/client'
import { Modal, Paper, Slide, Typography } from '@material-ui/core'
import WalletIcon from '@material-ui/icons/AccountBalanceWalletRounded'
import React, { useEffect } from 'react'

import { REFERENCES_QUERY } from '../../../graphql/walletQueries'
import { getDirection, getTranslate } from '../../../localization'
import { Reference } from '../../../types/walletReferences'
import ReferenceRow from './ReferenceRow'
import { ReferenceRowSkeleton } from './ReferenceRow.skeleton'
import useStyles from './styles/index.styles'

interface ReferencesModalProps {
  isOpen: boolean
  onClose: () => void
  transactionID: string
}

const ReferencesModal: React.FC<ReferencesModalProps> = ({
  isOpen,
  onClose,
  transactionID
}) => {
  const classes = useStyles()
  const [getReferences, { data, loading }] = useLazyQuery(REFERENCES_QUERY)
  useEffect(() => {
    if (isOpen) {
      getReferences({
        variables: {
          transactionID: transactionID
        }
      })
    }
  }, [isOpen])

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <WalletIcon className={classes.CardMembershipIcon} color="primary" />
          <Typography variant="h3" className={classes.title} color="secondary">
            {getTranslate('References')}
          </Typography>
          <div className={classes.tableheader}>
            <div>
              <Typography variant="h4">{getTranslate('Type')}</Typography>
            </div>
            <div>
              <Typography variant="h4">{getTranslate('id')}</Typography>
            </div>
            <div />
          </div>
          {loading
            ? Array(3)
                .fill(null)
                .map((item, index) => (
                  <ReferenceRowSkeleton key={index.toString()} />
                ))
            : data?.references.map((ref: Reference) => (
                <ReferenceRow reference={ref} />
              ))}
        </Paper>
      </Slide>
    </Modal>
  )
}
export default ReferencesModal
